export default "__VITE_ASSET__CDXEDHw9__"